"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));

var _TooltipCoachmark = _interopRequireDefault(require("../baseComponents/TooltipCoachmark"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InformationTooltip = function InformationTooltip(props) {
  var _React$createElement;

  var myRef = /*#__PURE__*/_react["default"].createRef();

  var newID = props.id;

  if (newID === null) {
    newID = "-box-" + Math.floor(Math.random() * 100000000);
  }

  var hasIcon = props.iconName !== "" && props.iconType !== "";
  var classes = (0, _classnames["default"])("informationTooltip-component", props.className, newID, {
    "hasNoIcon": !hasIcon
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    style: props.style
  }, props.text !== "" && /*#__PURE__*/_react["default"].createElement("p", (_React$createElement = {
    className: "narrow"
  }, _defineProperty(_React$createElement, "className", (0, _classnames["default"])("text-container".concat(newID), props.borderUnderText && "only-text")), _defineProperty(_React$createElement, "onClick", function onClick() {
    myRef.show();
  }), _React$createElement), props.text), hasIcon && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    isAction: true,
    name: props.iconName,
    type: props.iconType,
    classNameContainer: (0, _classnames["default"])("icon-container".concat(newID), props.iconOriginalColor && "iconOriginalColor"),
    onClick: function onClick() {
      myRef.show();
    }
  }), (props.text !== "" || props.iconName !== "") && /*#__PURE__*/_react["default"].createElement(_TooltipCoachmark["default"], {
    ref: function ref(tooltip) {
      myRef = tooltip;
    },
    context: ".".concat(newID),
    defaultEvent: true,
    color: props.tooltipColor,
    adjustedXY: props.adjustedXY,
    title: props.tooltipTitle,
    text: props.tooltipTitle ? props.tooltipText : null,
    type: props.tooltipTitle ? "coachmark-text" : "tooltip",
    position: props.tooltipPosition,
    arrowPosition: props.tooltipArrowPosition
  }, !props.tooltipTitle && /*#__PURE__*/_react["default"].createElement("p", null, props.tooltipText)));
};

InformationTooltip.propTypes = {
  tooltipTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  iconName: _propTypes["default"].string,
  iconType: _propTypes["default"].string,
  iconOriginalColor: _propTypes["default"].bool,
  borderUnderText: _propTypes["default"].bool,
  tooltipColor: _propTypes["default"].oneOf(["grey", "red", "coal", "onyx"]),
  tooltipText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  id: _propTypes["default"].string,
  adjustedXY: _propTypes["default"].object,
  tooltipPosition: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["top", "right", "bottom", "left"]), _propTypes["default"].array]),
  tooltipArrowPosition: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["arrow-top", "arrow-right", "arrow-bottom", "arrow-left"]), _propTypes["default"].array])
};
InformationTooltip.defaultProps = {
  tooltipPosition: "top",
  tooltipArrowPosition: "arrow-left",
  tooltipTitle: null,
  text: "",
  iconName: "",
  iconType: "glyph",
  borderUnderText: false,
  iconOriginalColor: false,
  tooltipColor: "grey",
  tooltipText: "",
  classNames: "",
  style: {},
  id: null,
  adjustedXY: {
    'x': 0,
    'y': 0
  }
};
var _default = InformationTooltip;
exports["default"] = _default;